<div class="flex flex-v-center flex-gap4">

  @if (showAlertMessages && warningText?.length > 0) {
    <div class="additional-info">
      <mat-icon class="icon text-orange opacity50" [ngClass]="{'clear-opacity': highlight}" [matTooltip]="warningText"
        matTooltipClass="big-multiline-tooltip">
        warning
      </mat-icon>
    </div>
  }

  @if (showAlertMessages && alertText?.length > 0) {
    <div class="additional-info flex flex-v-center">
      <mat-icon class="icon text-red opacity50"
        [ngClass]="{'clear-opacity': highlight}"
        [matTooltip]="alertText"
        matTooltipClass="big-multiline-tooltip">
        error
      </mat-icon>
    </div>
  }

  @if (secondsAgo > 0) {
    <div class="additional-info flex flex-v-center" [ngClass]="{'highlight': highlight}"
      [matTooltip]="'term.last-message'|translate"
      [matTooltipShowDelay]="600">
      <mat-icon class="icon">timer</mat-icon>
      <div>{{ secondsAgo | timeFromNowText }}</div>
    </div>
  }

  @if (showZeroSpeed || speed > STOP_SPEED) {
    <div class="additional-info flex flex-v-center"
      [ngClass]="{'highlight': highlight}"
      [matTooltip]="'term.speed'|translate"
      [matTooltipShowDelay]="600">
      <mat-icon class="icon">speed</mat-icon>
      <span>{{ speed }} {{ 'uom.km-h' | translate }}</span>
    </div>
  }

  @if (driver) {
    <div class="additional-info" [ngClass]="{'highlight': highlight}">
      <app-driver-with-avatar [driver]="driver">
      </app-driver-with-avatar>
    </div>
  }
</div>
